export const Header: React.FC = () => {
  return (
    <div className='flex items-center justify-between p-2 py-3 border-b-2 bg-white border-b-slate-300'>
      <div className='max-w-[270px]'></div>
      <div className='max-w-[270px]'></div>
    </div>
  )
}
